import React from 'react';
import cn from 'clsx';

import Button from '../../library/button/button';
import { FileInvoiceDollarRegularIcon } from '../../shared/icons/icons';

import { useModal, useMyAccount } from '../../shared/hooks/hooks';

import {
  isCanonicalProduct,
  isVirtualAssortmentParentProduct,
  isWebOnlyProduct
} from '../../shared/utils/product/product';

import { ProductItem } from '../../shared/types/product';
import * as MODAL_TYPES from '../../shared/constants/modals';

import styles from './found-it-lower-button.scss';

enum FoundItLowerTheme {
  BLUE = 'blue',
  GREY = 'grey'
}

enum FoundItLowerArrowOrientation {
  LEFT = 'left',
  RIGHT = 'right'
}

interface FoundItLowerButtonProps {
  analyticsPrefix?: string;
  arrowOrientation?: FoundItLowerArrowOrientation;
  className?: string;
  hideIcon?: boolean;
  hideMatchItText?: boolean;
  productItem: ProductItem;
  theme?: FoundItLowerTheme;
}

function FoundItLowerButton(props: FoundItLowerButtonProps) {
  const {
    analyticsPrefix = '',
    arrowOrientation,
    className,
    hideIcon = false,
    hideMatchItText = false,
    productItem,
    theme = FoundItLowerTheme.GREY
  } = props;
  const { product } = productItem || {};

  const { openModal } = useModal();
  const { isFleetAccount } = useMyAccount();

  const isWebOnly = isWebOnlyProduct(product);
  const isCanonical = isCanonicalProduct(product);
  const isVirtualAssortmentParent = isVirtualAssortmentParentProduct(product);
  const { mapDisplayRule, mapRuleSatisfied } = product || {};

  if (
    isFleetAccount ||
    isCanonical ||
    isWebOnly ||
    isVirtualAssortmentParent ||
    (mapRuleSatisfied && !mapDisplayRule?.mapPriceDisplay)
  ) {
    return null;
  }

  return (
    <Button
      className={cn(
        styles[`found-it-lower-${theme}`],
        arrowOrientation && styles[`arrow-${arrowOrientation}-container`],
        className,
        'found-it-lower-button'
      )}
      onClick={() => {
        openModal(MODAL_TYPES.FOUND_IT_LOWER_DRAWER, {
          analyticsPrefix,
          productItem
        });
      }}
    >
      {arrowOrientation === FoundItLowerArrowOrientation.LEFT && (
        <div className={styles['arrow-left']} />
      )}
      {!hideIcon && <FileInvoiceDollarRegularIcon className={styles['icon']} />}
      Found a lower price? {!hideMatchItText && "We'll match it!"}
      {arrowOrientation === FoundItLowerArrowOrientation.RIGHT && (
        <div className={styles['arrow-right']} />
      )}
    </Button>
  );
}

export { FoundItLowerArrowOrientation, FoundItLowerTheme };
export default FoundItLowerButton;
